import {ApiComm} from "../comm";
import { BookStatus, RecordType, ScriptStatus } from "../common/enums";
import {BookcaseInfoDTO, BookUserInfoDTO, BookUserInputReqDTO, BookUserMemoCntDTO, BookUserMemoDTO, BookUserRecordDTO, BookUserRecordTotalDTO, NoobookScheduleDTO, BookUserScriptDTO, BookcaseBookInfoDTO, BookUserStatisticsDTO} from "../dto/BookcaseDTOs";
import { NoobookFileInfoDTO } from "../dto/CommonDTOs";
import {ResponseDTO} from "../dto/ResponseDTO";
import {genNoobookHeader} from "./Common";
import _ from "lodash";




export function getBookcaseList(authToken:string, forReading:Boolean, forScript:Boolean):Promise<ResponseDTO<BookcaseInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookcaseInfoDTO[]>>('/close/v1/bookcase/list'
        , {name:null, forReading:forReading, forScript:forScript
            , page:0, size:300, sort:["bookcaseType,asc","name,asc"]}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function createBookcase(authToken:string, name:string, forReading:boolean, forScript:boolean):Promise<ResponseDTO<BookcaseInfoDTO>>
{
    return ApiComm.postData<ResponseDTO<BookcaseInfoDTO>>('/close/v1/bookcase'
        , {name:name, forReading:forReading, forScript:forScript}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function modifyBookcase(authToken:string, bookcaseId:number, name:string ):Promise<ResponseDTO<BookcaseInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookcaseInfoDTO>>(`/close/v1/bookcase/${bookcaseId}`
        , {name:name}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function deleteBookcase(authToken:string, bookcaseId:number):Promise<ResponseDTO<BookcaseInfoDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookcaseInfoDTO>>(`/close/v1/bookcase/${bookcaseId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function getBookcaseBooks(authToken:string, bookcaseId:number, title:string, page:number, size:number):Promise<ResponseDTO<BookcaseBookInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookcaseBookInfoDTO[]>>(`/close/v1/bookcase/${bookcaseId}/books`
        , {title:title, page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}





export function deleteBookcaseBook(authToken:string, bookcaseId:number, bookId:number):Promise<ResponseDTO<BookcaseBookInfoDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookcaseBookInfoDTO>>(`/close/v1/bookcase/${bookcaseId}/book/${bookId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function findMyBooksByReadTo(authToken:string, dateFr:Date, dateTo:Date):Promise<ResponseDTO<BookUserInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookUserInfoDTO[]>>(`/close/v1/bookcase/books/readTo`
        , {dateFr:dateFr, dateTo:dateTo, page:0, size:500}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function findMyBooksByReadFrTo(authToken:string, dateFr:Date, dateTo:Date):Promise<ResponseDTO<BookUserInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookUserInfoDTO[]>>(`/close/v1/bookcase/books/readFrTo`
        , {dateFr:dateFr, dateTo:dateTo, page:0, size:500}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}




export function findMyBooksByScriptTo(authToken:string, dateFr:Date, dateTo:Date):Promise<ResponseDTO<BookUserInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookUserInfoDTO[]>>(`/close/v1/bookcase/books/scriptTo`
        , {dateFr:dateFr, dateTo:dateTo, page:0, size:500}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function findMyBooksByScriptFrTo(authToken:string, dateFr:Date, dateTo:Date):Promise<ResponseDTO<BookUserInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookUserInfoDTO[]>>(`/close/v1/bookcase/books/scriptFrTo`
        , {dateFr:dateFr, dateTo:dateTo, page:0, size:500}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}




export function countMyBooksByReadToOrScriptTo(authToken:string, dateFr:Date, dateTo:Date):Promise<ResponseDTO<BookUserMemoCntDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookUserMemoCntDTO[]>>(`/close/v1/bookcase/books/memo/count`
        , {dateFr:dateFr, dateTo:dateTo, page:0, size:500}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function getSchedulesForTheDay(authToken:string, theDate:Date):Promise<ResponseDTO<NoobookScheduleDTO[]>>
{
    return ApiComm.getData<ResponseDTO<NoobookScheduleDTO[]>>(`/close/v1/bookcase/book/schedules`
        , {theDate:theDate, page:0, size:300}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getMyBookByBookId(authToken:string, bookId:number):Promise<ResponseDTO<BookUserInfoDTO>>
{
    return ApiComm.getData<ResponseDTO<BookUserInfoDTO>>(`/close/v1/bookcase/book/${bookId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getMyBookByIsbn(authToken:string, isbn:string):Promise<ResponseDTO<BookUserInfoDTO>>
{
    return ApiComm.getData<ResponseDTO<BookUserInfoDTO>>(`/close/v1/bookcase/book/isbn/${isbn}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getMyBooksByStatus(authToken:string, bookStatus:BookStatus, scriptStatus:ScriptStatus, page:number, size:number):Promise<ResponseDTO<BookUserInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookUserInfoDTO[]>>(`/close/v1/bookcase/books/status`
        , {bookStatus:bookStatus, scriptStatus:scriptStatus, page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getMyBooksWishToRead(authToken:string, page:number, size:number):Promise<ResponseDTO<BookUserInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookUserInfoDTO[]>>(`/close/v1/bookcase/wishToRead/books`
        , {page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getMyBooksWishToScript(authToken:string, page:number, size:number):Promise<ResponseDTO<BookUserInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookUserInfoDTO[]>>(`/close/v1/bookcase/wishToScript/books`
        , {page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function putMyBookByBookId(authToken:string, bookId:number, bookUserInputReqDTO:BookUserInputReqDTO):Promise<ResponseDTO<BookUserInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookUserInfoDTO>>(`/close/v1/bookcase/book/${bookId}`
        , bookUserInputReqDTO
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function putMyBookByIsbn(authToken:string, isbn:string, bookUserInputReqDTO:BookUserInputReqDTO):Promise<ResponseDTO<BookUserInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookUserInfoDTO>>(`/close/v1/bookcase/book/isbn/${isbn}`
        , bookUserInputReqDTO
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function putMyBookScore(authToken:string, bookId:number, score:number):Promise<ResponseDTO<BookUserInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookUserInfoDTO>>(`/close/v1/bookcase/book/${bookId}/score/${score}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function putMyBookReadPage(authToken:string, bookId:number, readPage:number):Promise<ResponseDTO<BookUserInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookUserInfoDTO>>(`/close/v1/bookcase/book/${bookId}/readPage/${readPage}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function putMyBookScriptPage(authToken:string, bookId:number, scriptPage:number):Promise<ResponseDTO<BookUserInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookUserInfoDTO>>(`/close/v1/bookcase/book/${bookId}/scriptPage/${scriptPage}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function putMyBookReadDone(authToken:string, bookId:number):Promise<ResponseDTO<BookUserInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookUserInfoDTO>>(`/close/v1/bookcase/book/${bookId}/readDone`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function putMyBookScriptDone(authToken:string, bookId:number):Promise<ResponseDTO<BookUserInfoDTO>>
{
    return ApiComm.putData<ResponseDTO<BookUserInfoDTO>>(`/close/v1/bookcase/book/${bookId}/scriptDone`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getMyBookMemos(authToken:string, bookId:number, page:number, size:number):Promise<ResponseDTO<BookUserMemoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookUserMemoDTO[]>>(`/close/v1/bookcase/book/${bookId}/memos`
        , {page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getMyBookScripts(authToken:string, bookId:number, page:number, size:number):Promise<ResponseDTO<BookUserScriptDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookUserScriptDTO[]>>(`/close/v1/bookcase/book/${bookId}/scripts`
        , {page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function uploadScriptImageToTmpFile(authToken:string, file:File):Promise<ResponseDTO<NoobookFileInfoDTO>>
{
    return ApiComm.postFormData<ResponseDTO<NoobookFileInfoDTO>>(`/close/v1/bookcase/book/script/image`
        , {file:file}
        , genNoobookHeader(authToken, null, 'multipart/form-data', "app")
    ).then(resp=>resp.data);
}

export function addMyBookScript(authToken:string, bookId:number, tmpImgFileId:string):Promise<ResponseDTO<BookUserScriptDTO>>
{
    //console.log('addMyBookScript', authToken, bookId, tmpImgFileId);
    return ApiComm.postData<ResponseDTO<BookUserScriptDTO>>(`/close/v1/bookcase/book/${bookId}/script`
        , {tmpImgFileId:tmpImgFileId}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function modifyMyBookScript(authToken:string, scriptId:number, tmpImgFileId:string):Promise<ResponseDTO<BookUserScriptDTO>>
{
    console.log('modifyMyBookScript', authToken, scriptId, tmpImgFileId);
    return ApiComm.putData<ResponseDTO<BookUserScriptDTO>>(`/close/v1/bookcase/book/script/${scriptId}`
        , {tmpImgFileId:tmpImgFileId}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function deleteMyBookScript(authToken:string, scriptId:number):Promise<ResponseDTO<BookUserScriptDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookUserScriptDTO>>(`/close/v1/bookcase/book/script/${scriptId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}




export function addMyBookMemo(authToken:string, bookId:number, memo:string):Promise<ResponseDTO<BookUserMemoDTO>>
{
    console.log('addMyBookMemo', authToken, bookId, memo);
    return ApiComm.postData<ResponseDTO<BookUserMemoDTO>>(`/close/v1/bookcase/book/${bookId}/memo`
        , {memo:memo}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function modifyMyBookMemo(authToken:string, memoId:number, memo:string):Promise<ResponseDTO<BookUserMemoDTO>>
{
    //console.log('modifyMyBookMemo', authToken, memoId, memo);
    return ApiComm.putData<ResponseDTO<BookUserMemoDTO>>(`/close/v1/bookcase/book/memo/${memoId}`
        , {memo:memo}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function deleteMyBookMemo(authToken:string, memoId:number):Promise<ResponseDTO<BookUserMemoDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookUserMemoDTO>>(`/close/v1/bookcase/book/memo/${memoId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getMyBookRecords(authToken:string, bookId:number, recordType:RecordType, page:number, size:number):Promise<ResponseDTO<BookUserRecordDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookUserRecordDTO[]>>(`/close/v1/bookcase/book/${bookId}/records`
        , {recordType:recordType, page:page, size:size}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function deleteMyBookRecord(authToken:string, recordId:number):Promise<ResponseDTO<BookUserRecordDTO>>
{
    return ApiComm.deleteData<ResponseDTO<BookUserRecordDTO>>(`/close/v1/bookcase/book/record/${recordId}`
        , {}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getTotalRecordInSec(authToken:string, bookId:number, recordType:RecordType):Promise<ResponseDTO<number>>
{
    return ApiComm.getData<ResponseDTO<number>>(`/close/v1/bookcase/book/${bookId}/totalRecordInSec`
        , {recordType:recordType}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}


export function getTotalRecord(authToken:string, bookId:number, recordType:RecordType):Promise<ResponseDTO<BookUserRecordTotalDTO>>
{
    return ApiComm.getData<ResponseDTO<BookUserRecordTotalDTO>>(`/close/v1/bookcase/book/${bookId}/totalRecord`
        , {recordType:recordType}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}





export function putMyBookRecord(authToken:string, bookId:number, recordType:RecordType, startAt:Date, endAt:Date):Promise<ResponseDTO<BookUserRecordDTO>>
{
    return ApiComm.putData<ResponseDTO<BookUserRecordDTO>>(`/close/v1/bookcase/book/${bookId}/record`
        , {recordType:recordType, startAt:startAt, endAt:endAt}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

export function getMyBookUserStatistics(authToken:string, recordType:RecordType):Promise<ResponseDTO<BookUserStatisticsDTO>>
{
    return ApiComm.getData<ResponseDTO<BookUserStatisticsDTO>>(`/close/v1/bookcase/books/statistics`
        , {recordType:recordType}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}

/*
@GetMapping("/books/statistics")
	public BookUserStatisticsDTO getMyBookUserStatistics(@UserAccount UserAccountDTO loginUser
			, @RequestParam(name="recordType")RecordType recordType) throws NoobookBaseException {
		return this.bookcaseService.getBookUserStatistics(loginUser.getUserId(), recordType);
	}

	

/*
@GetMapping("/search/isbn/{isbn}")
	public BookUserInfoDTO getMyBookByIsbn(@UserAccount UserAccountDTO loginUser
			, @RequestParam(name="isbn", required=true)String isbn )



public Page<BookcaseInfoDTO> getBookcaseList(@UserAccount UserAccountDTO loginUser
			, @RequestParam(name="name", required=false)String name 
			, @RequestParam(name="forReading", required=false)Boolean forReading 
			, @RequestParam(name="forScript", required=false)Boolean forScript 
			, Pageable pageable) throws NoobookBaseException 
*/

